/* eslint-disable */
import React, { createContext, useState, useEffect } from "react"
import {
  getMondayOfCurrentWeek,
  getSundayOfCurrentWeek,
  thisWeekRange,
} from "../utils/date.utils"
import {
  getActiveClients,
  getActiveClientsOfTeamLeader,
} from "../services/client.service"
import {
  getActiveProjects,
  getTeamMemberActiveProjects,
} from "../services/project.service"
import { useSession } from "../hooks/auth/useSession.hook"
import { Role } from "../consts/roles.consts"
import { DateTime } from "luxon"
import { UNIFIEDDATE_VALUES } from "../consts/CompoundRangeDatePicker"

export const DASHBOARD_PERIOD_VALUES = {
  WEEKLY: "Semanal",
  MONTHLY: "Mensual",
}

export const ReportFiltersContext = createContext()
export const ReportFiltersContextProvider = ({ children }) => {
  const INITIAL_SELECTED_CLIENT = null

  const auth = useSession()

  const [weekHoursDateRange, setWeekHoursDateRange] = useState([
    DateTime.local().startOf("week"),
    DateTime.local().startOf("week"),
  ])

  //***** Rendimiento por proyectos

  const [projectsPerformanceDateRange, setProjectsPerformanceDateRange] =
    useState([DateTime.local(), DateTime.local()])
  const [projectsPerformancePeriod, setProjectsPerformancePeriod] = useState(
    UNIFIEDDATE_VALUES.SINGLEDAY
  )
  const [projectsPerformanceExpandedKeys, setProjectsPerformanceExpandedKeys] =
    useState({})

  //***** Tareas por cliente

  const [tasksByClientClients, setTasksByClientClients] = useState([])
  const [tasksByClientSelectedClient, setTasksByClientSelectedClient] =
    useState(INITIAL_SELECTED_CLIENT)
  const [tasksByClientPeriod, setTasksByClientPeriod] = useState(
    UNIFIEDDATE_VALUES.SINGLEWEEK
  )
  const [tasksByClientDateRange, setTasksByClientDateRange] =
    useState(thisWeekRange())

  const updateClientDropdown = async () => {
    let response
    let clientData = []
    if (auth.user?.projectRole === Role.TEAM_LEADER) {
      response = await getActiveClientsOfTeamLeader()
    } else {
      response = await getActiveClients()
    }
    if (response.success) {
      response.result.forEach((client) => {
        clientData.push(client.data)
      })
      if (clientData.length === 1) {
        setTasksByClientSelectedClient(clientData[0].code)
      }
    }
    setTasksByClientClients(clientData)
  }

  //***** Reporte de cliente
  const [clientReportSelectedClientCode, setClientReportSelectedClientCode] =
    useState("")
  const [clientReportSelectedClientName, setClientReportSelectedClientName] =
    useState("")
  const [clientReportSelectedClientLogo, setClientReportSelectedClientLogo] =
  useState("")
  const [clientReportClients, setClientReportClients] = useState([])
  const [clientReportSelectedClient, setClientReportSelectedClient] = useState(
    INITIAL_SELECTED_CLIENT
  )
  const [
    isClientReportSelectedClientBillable,
    setIsClientReportSelectedClientBillable,
  ] = useState(false)

  const updateClientReportDropdown = async () => {
    let response
    let clientData = []
    if (auth.user?.projectRole === Role.TEAM_LEADER) {
      response = await getActiveClientsOfTeamLeader()
    } else {
      response = await getActiveClients()
    }
    if (response.success) {
      response.result.forEach((client) => {
        // if (SISU_CLIENTS.includes(client.data.clientId)) return
        clientData.push(client.data)
      })
      setClientReportSelectedClient(clientData?.[0]?.clientId)
      setIsClientReportSelectedClientBillable(clientData?.[0]?.isBillable)
      setClientReportSelectedClientName(clientData?.[0]?.name || "")
      setClientReportSelectedClientLogo(clientData?.[0]?.clientLogo || "")
    }
    setClientReportClients(clientData)
  }

  //***************

  const [teamHoursConsumptionProjects, setTeamHoursConsumptionProjects] =
    useState([])
  const [
    teamHoursConsumptionSelectedProject,
    setTeamHoursConsumptionSelectedProject,
  ] = useState(INITIAL_SELECTED_CLIENT)
  const [teamHoursConsumptionPeriod, setTeamHoursConsumptionPeriod] = useState(
    UNIFIEDDATE_VALUES.RANGEWEEK
  )
  const [teamHoursConsumptionDateRange, setTeamHoursConsumptionDateRange] =
    useState([DateTime.local().startOf("week"), DateTime.local().endOf("week")])
  const [
    teamHoursConsumptionExpandedKeys,
    setTeamHoursConsumptionExpandedKeys,
  ] = useState({})

  //***** Consumo por integrante

  const [memberConsumptionTeamMembers, setMemberConsumptionTeamMembers] =
    useState([])
  const [
    memberConsumptionSelectedTeamMembers,
    setMemberConsumptionSelectedTeamMembers,
  ] = useState([])
  const [memberConsumptionDateRange, setMemberConsumptionDateRange] = useState([
    DateTime.local(),
    DateTime.local(),
  ])
  const [memberConsumptionPeriod, setMemberConsumptionPeriod] = useState(
    UNIFIEDDATE_VALUES.SINGLEDAY
  )

  //***** Occupation Report States
  const [occupationReportDateRange, setOccupationReportDateRange] = useState([
    DateTime.local().startOf("year"),
    DateTime.local().endOf("Year"),
  ])
  const [occupationReportChartsDateRange, setOccupationReportChartsDateRange] =
    useState([DateTime.local().startOf("year"), DateTime.local()])
  const [
    occupationReportChartsTemporalHoursTypeFilter,
    setOccupationReportChartsTemporalHoursTypeFilter,
  ] = useState([])

  //***** Dashboard State

  const [dashboardPeriod, setDashboardPeriod] = useState(
    DASHBOARD_PERIOD_VALUES.WEEKLY
  )

  const isMonday = DateTime.local().weekday === 1

  const [dashboardDateRange, setDashboardRange] = useState([
    getMondayOfCurrentWeek().minus({ weeks: isMonday ? 1 : 0 }),
    getSundayOfCurrentWeek().minus({ weeks: isMonday ? 1 : 0 }),
  ])

  //****************

  useEffect(() => {
    updateClientDropdown()
    updateProjectDropdown()
    updateClientReportDropdown()
  }, [])

  const updateProjectDropdown = async () => {
    let response
    let projectData = []
    if (
      auth.user?.projectRole === Role.ADMIN ||
      auth.user?.projectRole === Role.ADMIN_WITHOUT_REPORT
    ) {
      response = await getActiveProjects()
    } else {
      response = await getTeamMemberActiveProjects(auth.user?.teamMemberID)
    }
    if (response.success) {
      response.result.forEach((project) => {
        if (project.projectID !== 1) projectData.push(project)
      })
      if (projectData.length === 1) {
        setTeamHoursConsumptionSelectedProject(projectData[0].projectTagName)
      }
    }
    setTeamHoursConsumptionProjects(projectData)
  }

  const refreshFiltersContext = () => {
    updateClientDropdown()
    updateProjectDropdown()
  }

  return (
    <ReportFiltersContext.Provider
      value={{
        weekHoursDateRange,
        setWeekHoursDateRange,
        //
        projectsPerformanceDateRange,
        setProjectsPerformanceDateRange,
        projectsPerformanceExpandedKeys,
        setProjectsPerformanceExpandedKeys,
        projectsPerformancePeriod,
        setProjectsPerformancePeriod,
        //
        tasksByClientClients,
        setTasksByClientClients,
        tasksByClientSelectedClient,
        setTasksByClientSelectedClient,
        tasksByClientPeriod,
        setTasksByClientPeriod,
        tasksByClientDateRange,
        setTasksByClientDateRange,
        //
        clientReportClients,
        setClientReportClients,
        clientReportSelectedClient,
        setClientReportSelectedClient,
        isClientReportSelectedClientBillable,
        setIsClientReportSelectedClientBillable,
        updateClientReportDropdown,
        clientReportSelectedClientCode,
        setClientReportSelectedClientCode,
        clientReportSelectedClientName,
        setClientReportSelectedClientName,
        clientReportSelectedClientLogo,
        setClientReportSelectedClientLogo,
        //
        teamHoursConsumptionProjects,
        setTeamHoursConsumptionProjects,
        teamHoursConsumptionSelectedProject,
        setTeamHoursConsumptionSelectedProject,
        teamHoursConsumptionPeriod,
        setTeamHoursConsumptionPeriod,
        teamHoursConsumptionDateRange,
        setTeamHoursConsumptionDateRange,
        teamHoursConsumptionExpandedKeys,
        setTeamHoursConsumptionExpandedKeys,
        //
        memberConsumptionTeamMembers,
        setMemberConsumptionTeamMembers,
        memberConsumptionSelectedTeamMembers,
        setMemberConsumptionSelectedTeamMembers,
        memberConsumptionDateRange,
        setMemberConsumptionDateRange,
        memberConsumptionPeriod,
        setMemberConsumptionPeriod,
        //
        occupationReportDateRange,
        setOccupationReportDateRange,
        occupationReportChartsDateRange,
        setOccupationReportChartsDateRange,
        occupationReportChartsTemporalHoursTypeFilter,
        setOccupationReportChartsTemporalHoursTypeFilter,
        //
        dashboardPeriod,
        setDashboardPeriod,
        dashboardDateRange,
        setDashboardRange,
        //
        refreshFiltersContext,
      }}
    >
      {children}
    </ReportFiltersContext.Provider>
  )
}
